import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import { IdeaStatus } from '../interfaces'

import TopicMetadata from './TopicMetadata'
import TopicPills from './TopicPills'
import TopicTitle from './TopicTitle'

export interface TopicInfoProps {
  title: string
  contentType: ContentType
  publicId: string
  trashed: boolean
  spam: boolean
  publishedAt: string
  replyCount: number
  views: number
  publicLabel: string | null
  votes?: number
  likes?: number
  ideationStatus?: IdeaStatus
  pending: boolean
  destinationUrl: string
}

class TopicInfo extends PureComponent<TopicInfoProps> {
  render() {
    const {
      title,
      contentType,
      publicId,
      trashed,
      spam,
      ideationStatus,
      publicLabel,
      replyCount,
      views,
      publishedAt,
      votes,
      likes,
      pending,
      destinationUrl
    } = this.props
    return (
      <section id='topic-moderation--topic-info'>
        <TopicPills
          trashed={trashed}
          spam={spam}
          ideationStatus={ideationStatus}
          publicLabel={publicLabel}
          pending={pending}
        />
        <TopicTitle title={title} contentType={contentType} publicId={publicId} destinationUrl={destinationUrl} />
        <TopicMetadata
          publishedAt={publishedAt}
          replyCount={replyCount}
          views={views}
          votes={votes}
          likes={likes}
        />
      </section>
    )
  }
}

export default TopicInfo
